export const RED = '#C53030';
export const BLUE = '#2B6CB0';
export const LIGHT_RED = '#FED7D7';
export const LIGHT_BLUE = '#BEE3F8';
